module.exports = __webpack_public_path__ + "media/theme/logo-dcd52de1.svg";